export default __webpack_public_path__ + "static/media/doc.39d7d79e.png";